import { useEffect, useState, Fragment } from "react";
import { useSelector } from "react-redux";
import { ChevronDown } from "lucide-react";

import classes from "./filter.module.scss";
import CustomInputCheckbox from "@/components/desktop/form/input/input-checkbox/CustomInputCheckbox";

const FilterEstateParent = ({ filterEstateParent, filterEstate, changeEstateParentFilter, changeEstateFilter }) => {
	const { user } = useSelector((state) => state.auth);
	const [localEstatesParents, setLocalEstatesParents] = useState([]);
	const [hasAutoSelected, setHasAutoSelected] = useState(false);

	useEffect(() => {
		if (user && user.estates_parents) {
			setLocalEstatesParents(user.estates_parents);
		}
	}, [user]);

	useEffect(() => {
		if (!hasAutoSelected && user?.estates_parents?.length && !filterEstateParent.length) {
			changeEstateParentFilter("ALL");
			setHasAutoSelected(true);
		}
	}, [changeEstateParentFilter, filterEstateParent.length, hasAutoSelected, user?.estates_parents?.length]);

	const selectedParents = (filterEstateParent || []).map(Number);
	const selectedEstates = (filterEstate || []).map(Number);
	const allParentsSelected = Boolean(user?.estates_parents?.length) && selectedParents.length === user.estates_parents.length;

	return (
		<div className={classes.filterSection}>
			<hr className={classes.divider} />

			<div>
				<h4>Campos</h4>

				<div className={classes.checkboxRow}>
					<CustomInputCheckbox
						options={[{ value: "ALL", label: "" }]}
						value={allParentsSelected ? ["ALL"] : []}
						onChange={() => changeEstateParentFilter("ALL")}
						direction="vertical"
					/>
					<span className={classes.parentToggleLabel} onClick={() => changeEstateParentFilter("ALL")}>
						Todos
					</span>
				</div>

				{user &&
					localEstatesParents.map((estateParent, index) => {
						const estatesForParent = user.estates?.filter((e) => String(e.estate_parent_id) === String(estateParent.value)) || [];
						const isOpen = estateParent.show_estate;
						const parentValue = Number(estateParent.value);
						const isChecked = selectedParents.includes(parentValue);

						const handleToggle = () => {
							const updated = [...localEstatesParents];
							updated[index] = { ...estateParent, show_estate: !estateParent.show_estate };
							setLocalEstatesParents(updated);
						};

						return (
							<Fragment key={index}>
								<div className={classes.checkboxRow}>
									<CustomInputCheckbox
										options={[{ value: parentValue, label: "" }]}
										value={isChecked ? [parentValue] : []}
										onChange={(values) => {
											const nextChecked = values.includes(parentValue);
											if (nextChecked !== isChecked) changeEstateParentFilter(parentValue);
										}}
										direction="vertical"
									/>
									<span
										className={classes.parentToggleLabel}
										onClick={(event) => {
											event.stopPropagation();
											handleToggle();
										}}
									>
										{estateParent.label}
										{estatesForParent.length > 0 && (
											<ChevronDown size={16} className={`${classes.arrowToggle} ${isOpen ? classes.rotated : ""}`} />
										)}
									</span>
								</div>

								{isOpen && estatesForParent.length > 0 && (
									<div className={classes.nestedItems}>
										<CustomInputCheckbox
											options={estatesForParent.map((e) => ({ value: Number(e.value), label: e.label }))}
											value={selectedEstates}
											onChange={(values) => {
												const added = values.find((v) => !selectedEstates.includes(v));
												const removed = selectedEstates.find((v) => !values.includes(v));
												if (added !== undefined) changeEstateFilter(added);
												if (removed !== undefined) changeEstateFilter(removed);
											}}
											direction="vertical"
										/>
									</div>
								)}
							</Fragment>
						);
					})}
			</div>
		</div>
	);
};

export default FilterEstateParent;
